/**
 * render function for DesRtpmUserCell
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */

import React from 'react';
import _ from 'lodash';
import AwCheckbox from 'viewmodel/AwCheckboxViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import eventBus from 'js/eventBus';
import { publish } from 'js/desCatalogEventBus';
import modelPropertyService from 'js/modelPropertyService';
import appCtxSvc from 'js/appCtxService';

let bucketSizeArray;
let panelBucketsCountMap;
let renderCountMap = false;
const initialBucketLength = 5;

/**
 * Chat cell render function.
 *
 * @param {*} props
 * @returns {string} html string.
 */
export const desSearchFilterCellRenderFunction = (props) => {
    const {
        vmo,
        i18n,
        viewModel
    } = props;

    const totalFacetCount = vmo && vmo.length ? vmo.length : 0;

    if (renderCountMap === false) {
        panelBucketsCountMap = new Map;
        bucketSizeArray = Array.from({ length: totalFacetCount }, () => initialBucketLength);
        for (let i = 0; i < totalFacetCount; i++) {
            panelBucketsCountMap.set(props.vmo[i].name, bucketSizeArray[i]);
        }
    }
    else{
        renderCountMap = false;
    }

    /**
     * Render checkbox
     * @param {Object} bucket object
     * @param {Number} bucketIndex
     * @returns
     */

    const processBuckets = (bucket, bucketIndex, currentItem) => {
        const searchFilterCheckBox = appCtxSvc.getCtx('disableSearchFilterCheckBox');
        // If `disableSearchFilterCheckBox` not defined register the variable.
        if(searchFilterCheckBox === undefined) {
            appCtxSvc.registerCtx('disableSearchFilterCheckBox', false);
        }
        const onChangeAction = (e) => {
            const eventData = {
                dbValue: e.target.checked,
                bucket,
                name: _.get(currentItem, 'name'),
                field: _.get(currentItem, 'field')
            };
            bucket.selectedValue = e.target.checked;
            viewModel.dispatch({ path: 'data', value: eventData });
            renderCountMap = true;
            // Disable checkbox until the n/w call not completed
            appCtxSvc.updateCtx('disableSearchFilterCheckBox', true);
            eventBus.publish('des-search-filter.selectionChange', eventData);
            publish('des-search-filter.selectionChange', eventData);
        };

        const disableSearchFilterCheckBox = appCtxSvc.getCtx('disableSearchFilterCheckBox');

        const displayName = _.get(bucket, 'name');
        const isChecked = _.get(bucket, 'selectedValue');
        const docCount = _.get(bucket,'doc_count');
        const checkBoxProps = {
            fielddata: {
                propertyDisplayName: `${displayName} (${docCount})`,
                type: 'BOOLEAN',
                isRequired: 'false',
                isEditable: 'true',
                labelPlacement: 'end'
            },
            onChange: onChangeAction,
            selected: false,
            checked: isChecked,
            disabled: disableSearchFilterCheckBox
        };
        return <AwCheckbox {...checkBoxProps} ></AwCheckbox>
    }

    const showMoreFacet = (sectionName, item) => {
        const currentSize = panelBucketsCountMap.get(sectionName) || 0;
        let newSize;
        if (item.buckets.length - currentSize > initialBucketLength) {
            newSize = currentSize + initialBucketLength;
        } else {
            newSize = currentSize + (item.buckets.length - currentSize);
        }
        panelBucketsCountMap.set(sectionName, newSize);
        viewModel.dispatch({ path: 'data', value: panelBucketsCountMap });
        renderCountMap = true;
    }

    const showLessFacet = (sectionName) => {
        const newSize = initialBucketLength;
        panelBucketsCountMap.set(sectionName, newSize);
        viewModel.dispatch({ path: 'data', value: panelBucketsCountMap });
        renderCountMap = true;
    }

    /**
     * Process panel section data
     * @param {Object} item panel item
     * @param {*} index
     * @returns JSX
     */
    const processPanelSection = (item, index) => {
        const captionName = item.name;
        let showMore;
        let showLess;
        // Auto collapsed logic
        let collapsed = false;
        if (index > 2) {
            collapsed = true;
        }
        const showMoreFacetHandler = () => {
            showMoreFacet(item.name, item);
        };

        const showLessFacetHandler = () => {
            showLessFacet(item.name);
        };

        const showMoreProp = {
            fielddata: modelPropertyService.createViewModelProperty({
                displayName: i18n.showMore,
                type: 'STRING',
                isRequired: false
            })
        };

        const showLessProp = {
            fielddata: modelPropertyService.createViewModelProperty({
                displayName: i18n.showLess,
                type: 'STRING',
                isRequired: false
            })
        };

        const itemsToShow = { ...item };
        if (item.buckets.length > panelBucketsCountMap.get(captionName)) {
            itemsToShow.buckets = item.buckets.slice(0, panelBucketsCountMap.get(captionName));
        }

        if (item.buckets.length > panelBucketsCountMap.get(captionName)) {
            showMore = true;
            showLess = false;
        } else if (item.buckets.length === panelBucketsCountMap.get(captionName) && item.buckets.length > initialBucketLength) {
            showMore = false;
            showLess = true;
        } else {
            showMore = false;
            showLess = false;
        }

        return (
            <AwPanelSection caption={captionName} className='des-aw-panel-section' collapsed={collapsed}>
                <AwFlexColumn>
                    <div>
                        {itemsToShow.buckets && itemsToShow.buckets.length > 0 && itemsToShow.buckets.map(function (bucket, bucketIndex) {
                            return processBuckets(bucket, bucketIndex, itemsToShow);
                        })}
                        {processEmptyItems(itemsToShow?.buckets)}
                    </div>
                    <div>
                        {showMore && (
                            <AwLink
                                className={`${item.name}-show-more`}
                                {...showMoreProp}
                                action={showMoreFacetHandler}
                            ></AwLink>
                        )}
                        {showLess && (
                            <AwLink
                                className={`${item.name}-show-less des-hide`}
                                {...showLessProp}
                                action={showLessFacetHandler}
                            ></AwLink>
                        )}
                    </div>
                </AwFlexColumn>
            </AwPanelSection>
        );
    };

    return (
        <AwPanel>
            <AwPanelBody>
                {vmo && vmo.length > 0 && vmo.map(processPanelSection)}
            </AwPanelBody>
        </AwPanel>
    );
};

const processEmptyItems = (bucketItems) => {
    return !bucketItems || bucketItems.length === 0 ? <div className='aw-widgets-noResultsLabel'>No data found.</div> : null;
}
